import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c8c193"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-layer" }
const _hoisted_2 = { class: "top-pane" }
const _hoisted_3 = ["onMouseenter", "onMouseleave"]
const _hoisted_4 = { class: "bottom-pane" }
const _hoisted_5 = ["onMouseenter", "onMouseleave"]
const _hoisted_6 = { class: "top-pane" }
const _hoisted_7 = ["onMouseenter", "onMouseleave"]
const _hoisted_8 = { class: "bottom-pane" }
const _hoisted_9 = ["onMouseenter", "onMouseleave"]

import { computed, ref, onMounted, onUnmounted } from 'vue'
import $ from 'jquery'
import RainPanel from '@/components/top/panels/RainPanel/RainPanel.vue'
import WaterPanel from '@/components/top/panels/WaterPanel/WaterPanel.vue'
import WeatherPanel from '@/components/top/panels/WeatherPanel/WeatherPanel.vue'
import ImagePanel from '@/components/top/panels/ImagePanel/ImagePanel.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { DefinitionInfoTopGraphicalMapPanel } from '@/models/initData/DefinitionInfo'

type InformationLayerPropsType = {
  mouseonStationId?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    mouseonStationId: null
  },
  emits: ['mouseenter', 'mouseleave'],
  setup(__props: any, { emit }) {

const props = __props as {
  mouseonStationId?: string
}



const HEADER_HEIGHT = 68
const ITEM_MARGIN = 10
const initDataStore = useInitDataStore()

const windowHeight = ref(window.innerHeight)

const cells = computed(() => {
  return initDataStore.initData.definitionInfo.top.graphical.topGraphical1
})

const columnStyle = computed(() => {
  const height = windowHeight.value - HEADER_HEIGHT

  return { height: `${height}px` }
})

const componentTypeName = (cell: DefinitionInfoTopGraphicalMapPanel) => {
  return cell.panelType === 'map_weather_type1'
    ? WeatherPanel
    : cell.panelType === 'map_water_type1'
    ? WaterPanel
    : cell.panelType === 'map_image_type1'
    ? ImagePanel
    : RainPanel
}

const setItemStyle = () => {
  $('.information-layer .information-column-item').each(function () {
    const $item = $(this)
    const $prevAll = $item.prevAll()
    const isTopPane = $item.closest('.top-pane').length > 0

    if ($prevAll.length === 0) {
      isTopPane ? $item.css({ top: 0 }) : $item.css({ bottom: 0 })
      return
    }

    const top = $prevAll
      .map(function () {
        return $(this).height()
      })
      .toArray()
      .reduce((prevHeight, memo) => {
        return prevHeight + ITEM_MARGIN + memo
      }, 0)

    isTopPane ? $item.css({ top: `${top}px` }) : $item.css({ bottom: `${top}px` })
  })
}

const itemStyle = (cell: DefinitionInfoTopGraphicalMapPanel) => {
  return props.mouseonStationId && cell.args.stationId === props.mouseonStationId ? 'active' : ''
}

const onResize = () => {
  windowHeight.value = window.innerHeight
  setItemStyle()
}

onMounted(() => {
  $(window).on('resize.top.information', onResize)
  $(window).trigger('resize.top.information')
})

onUnmounted(() => {
  $(window).off('resize.top.information')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(columnStyle)),
      class: "information-column left-pane"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells).left.top, (cell, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onMouseenter: ($event: any) => (emit('mouseenter', cell.args.stationId)),
            onMouseleave: ($event: any) => (emit('mouseleave', cell.args.stationId)),
            key: index,
            class: _normalizeClass([itemStyle(cell), "information-column-item"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(componentTypeName(cell)), { cell: cell }, null, 8, ["cell"]))
          ], 42, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells).left.bottom, (cell, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onMouseenter: ($event: any) => (emit('mouseenter', cell.args.stationId)),
            onMouseleave: ($event: any) => (emit('mouseleave', cell.args.stationId)),
            key: index,
            class: _normalizeClass([itemStyle(cell), "information-column-item"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(componentTypeName(cell)), { cell: cell }, null, 8, ["cell"]))
          ], 42, _hoisted_5))
        }), 128))
      ])
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(columnStyle)),
      class: "information-column right-pane"
    }, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells).right.top, (cell, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onMouseenter: ($event: any) => (emit('mouseenter', cell.args.stationId)),
            onMouseleave: ($event: any) => (emit('mouseleave', cell.args.stationId)),
            key: index,
            class: _normalizeClass([itemStyle(cell), "information-column-item"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(componentTypeName(cell)), { cell: cell }, null, 8, ["cell"]))
          ], 42, _hoisted_7))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells).right.bottom, (cell, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onMouseenter: ($event: any) => (emit('mouseenter', cell.args.stationId)),
            onMouseleave: ($event: any) => (emit('mouseleave', cell.args.stationId)),
            key: index,
            class: _normalizeClass([itemStyle(cell), "information-column-item"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(componentTypeName(cell)), {
              cell: cell,
              tb: 'bottom',
              lr: 'right'
            }, null, 8, ["cell"]))
          ], 42, _hoisted_9))
        }), 128))
      ])
    ], 4)
  ]))
}
}

})